<template>
  <div class="more-survey">
    <template v-if="hasMoreList">
      <div class="px-2">
        <div class="mb-3 leading-22 flex justify-between items-center" @click="onToTask">
          <span class="font-bold">更多问卷</span>
          <span class="cursor-pointer">
            <van-icon name="arrow" />
          </span>
        </div>
        <ul>
          <li v-for="item in moreSurveyList" :key="item.surveyId" class="survey-item" @click="openStartSurvey(item)">
            <div class="flex justify-between leading-22">
              <span class="truncate flex-1">
                {{ item.title }}
              </span>
              <span class="survey-price" v-if="item.amount">
                {{ item.amount ? '￥'+item.amount.toFixed(2) : '￥0.00' }}
              </span>
              <span class="survey-price text-medium" v-else>
                可抽奖
              </span>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <div class="text-center">
        <van-loading vertical> 加载更多中...</van-loading>
      </div>
    </template>
  </div>
</template>

<script>
import { busGetters, getMiniProgramScheme } from 'dygc'
import { Dialog } from 'vant'

export default {
  name: 'MoreSurvey',
  created() {
  },
  data() {
    return {
    }
  },
  computed: {
    hasMoreList() {
      return !!this.moreSurveyList
    },
    ...busGetters(['moreSurveyList'])
  },
  methods: {
    openStartSurvey(item) {
      if(item.isThirdParty) {
        const message = `
          <div><span class="text-center inline-block opacity-85 font-semibold text-large mb-2">此问卷为第三方问卷</span>\n<span class="text-center text-theme-black-450 text-medium">参与答题即可获得 <span class="text-danger">${item.partakeAmount || '0'}</span> 元红包奖励\n完成答题后可获得 <span class="text-danger">${item.amount || '0'}</span> 元红包奖励</span>\n<span class="text-center text-theme-black-250 text-medium">注：奖励不可兼得</span></div>
        `
        Dialog.confirm({
          title: '',
          message,
          width: '280px',
          confirmButtonColor: '#2775E8',
          className:'confirm-survey',
          confirmButtonText: '立即答题',
          getContainer: ".more-survey"
        }).then(() => {
          this.onStartSurvey(item)
        }).catch(() => {
        });
      }else {
        this.onStartSurvey(item)
      }
    },
    onStartSurvey(item) {
      this.$answerUtil.onStartMoreSurvey(item)
    },
    onToTask() {
      this.$answerUtil.getEnv().then(res => {
        if (res.miniprogram) {
          wx.miniProgram.redirectTo({ url: '/pages/index/index' })
        } else {
          this.$bus.openLoading()
          getMiniProgramScheme()
            .then(urlScheme => {
              this.$bus.closeLoading()
              if (urlScheme) {
                location.href = urlScheme
              }
            })
            .catch(() => {
              this.$bus.closeLoading()
            })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.confirm-survey {
  .van-dialog__message {
    padding: 0;
  }
}

</style>